import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H1, H2 } from '@r1-frontend/ui-react/components/typography/heading';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    grid-area: average;
    row-gap: 24px;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 100%;
    padding: 32px;
    padding-top: 24px;
    background-color: ${COLORS.BgSurface};
    border-radius: ${BorderRadius.OuterBlockRadius};
    row-gap: 24px;
    height: 356px;
    flex-wrap: nowrap;

    @media (max-width: ${wideBreakpoints.laptop}) {
        height: 404px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        height: fit-content;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 24px;
        row-gap: 16px;
    }
`;

export const Label = styled(H2)`
    width: max-content;
`;

export const GradeBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 12px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const GradeNumber = styled(H1)`
    font-size: 76px;
    line-height: 86px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        font-size: 40px;
        line-height: 52px;
    }
`;

export const Stars = styled.div`
    display: flex;
    flex-direction: row;
    column-gap: 2px;
    padding: 0 3.5px 2px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 0;
    }
`;

export const Star = styled(LazyLoadImage)<{ src: string }>`
    width: 56px;
    height: 53px;
    padding: 5px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 32px;
        height: 29px;
        padding: 3px;
    }
`;
